import { localStorage } from "@jog/shared"
import { useSession } from "next-auth/react"
import { PropsWithChildren, useEffect, useMemo, useState } from "react"
import { StatsigProvider as StatsigProviderBase, useGate as useGateBase } from "statsig-react"
import { v4 } from "uuid"

export const useGate = (gateName: string, ignoreOverrides?: boolean) => {
    const data = useGateBase(gateName, ignoreOverrides)
    const [value, setValue] = useState(false)
    useEffect(() => {
        setValue((v) => v || data.value)
    }, [data])
    return useMemo(() => ({ value, isLoading: data.isLoading }), [value, data.isLoading])
}
const StatsigState = () => {
    return <></>
}
export const StatsigProvider = ({ children }: PropsWithChildren) => {
    const key = process.env.NEXT_PUBLIC_STATSIG_CLIENT_API_KEY || ""
    const session = useSession()
    const user = useMemo(() => {
        if (session.status === "loading") return {}
        const userID = localStorage.getItem("statsigUserId") || v4()
        const email = session?.data?.user?.email || ""
        const preview = process.env.NEXT_PUBLIC_STATSIG_PREVIEW || ""
        return email ? { email, userID, custom: { preview } } : { userID, custom: { preview } }
    }, [session])
    useEffect(() => {
        if (user.userID) localStorage.setItem("statsigUserId", user.userID)
    }, [user])
    if (!key) return <>{children}</>
    return (
        <StatsigProviderBase sdkKey={key} user={user}>
            <StatsigState />
            {children}
        </StatsigProviderBase>
    )
}
